import { render, staticRenderFns } from "./PartnerDetails.vue?vue&type=template&id=0425ff80&scoped=true&"
import script from "./PartnerDetails.vue?vue&type=script&setup=true&lang=js&"
export * from "./PartnerDetails.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PartnerDetails.vue?vue&type=style&index=0&id=0425ff80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0425ff80",
  null
  
)

export default component.exports